import React from "react";
import CommonHeader from "../../../../components/CommonHeader";
import { Col } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import LabelContentComponent from "../LabelContentComponent";
import { IDonorDTO } from "../../../../../types/IDonorDTO";
import { Section } from "../../../../components/Section/Section";

interface PersonalInformationProps {
   loading: boolean;
   profileData: IDonorDTO | null;
   fullName: string;
   dateDisplay: string;
}
const PersonalInformation: React.FC<PersonalInformationProps> = ({
   loading,
   profileData,
   fullName,
   dateDisplay,
}) => {
   return (
      <Section className="personal-card-css">
         <CommonHeader title="PERSONAL INFORMATION" />
         <div className="personal-content-css">
            <Row className="personal-section-css">
               <Col>
                  <LabelContentComponent
                     loading={loading}
                     label={"First Name Last Name:"}
                     value={fullName}
                  />
               </Col>
               <Col>
                  <LabelContentComponent
                     loading={loading}
                     label={"Blood Type:"}
                     value={profileData ? profileData?.bloodType?.symbol : ""}
                  />
               </Col>
            </Row>
            <hr className="line-css" />
            <Row className="personal-section-css">
               <Col>
                  <LabelContentComponent loading={loading} label={"DOB:"} value={dateDisplay} />
               </Col>
               <Col>
                  <LabelContentComponent
                     loading={loading}
                     label={"CMV Status"}
                     value={profileData ? profileData?.cmvNegative : ""}
                  />
               </Col>
            </Row>
            <hr className="line-css" />
            <Row className="personal-section-css">
               <Col>
                  <LabelContentComponent
                     loading={loading}
                     label={"Sex:"}
                     value={profileData ? profileData?.sex?.description : ""}
                  />
               </Col>
               <Col>
                  <LabelContentComponent
                     loading={loading}
                     label={"Race:"}
                     value={profileData ? profileData?.race?.description : ""}
                  />
               </Col>
            </Row>
         </div>
      </Section>
   );
};

export default PersonalInformation;
